/**
 * Per-shell default open state for the chat drawer, as data.
 *
 * Extracted out of `shell-chat-defaults.ts` (which imports React and the
 * studio store, and so can never be imported from a store slice) so the
 * project-exit path can read the SAME numbers the shells apply, instead of
 * restating `false` at a second site where it would quietly drift.
 *
 * The contract is unchanged and still documented in `shell-chat-defaults.ts`:
 * the dashboard starts with the drawer closed, the IDE with it open.
 */
export type StudioShell = 'dashboard' | 'ide'

export const SHELL_CHAT_DRAWER_DEFAULT_OPEN: Record<StudioShell, boolean> = {
  dashboard: false,
  ide: true,
}
